export enum CsvJobStateEnum {
  PENDING = "pending",
  QUEUED = "queued",
  ERROR = "error",
}

export enum CsvJobNameEnum {
  TEAM_USERS = "team_users_csv_job",
  PROJECTS = "provider_leads_csv_job",
}

export enum CsvJobNameKeyEnum {
  TEAM_USERS = "teamUsersCsvJob",
  PROJECTS = "providerLeadsCsvJob",
}

export enum CsvReportNameEnum {
  TEAM_USERS = "TeamUsersCSV",
  ORG_TEAM_USERS = "OrgTeamUsersCSV",
  ORG_PRE_SALES_PROJECTS = "OrgPreSalesProjectsCSV",
  ORG_POST_SALES_PROJECTS = "OrgPostSalesProjectsCSV",
  ORG_COMPLETED_PROJECTS = "OrgCompletedProjectsCSV",
}
